import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

const USER_SUBORDINATE_API_RESOURCE = "user" as const;
const USER_SUBORDINATE_API_OPERATION = "subordinate" as const;
// eslint-disable-next-line typescript/no-unused-vars
const USER_SUBORDINATE_API_PATH =
  `/v1/${USER_SUBORDINATE_API_RESOURCE}/{uuid}/${USER_SUBORDINATE_API_OPERATION}` as const;

export type UserSubordinateParameters = paths[typeof USER_SUBORDINATE_API_PATH]["get"]["parameters"]["query"];
export type UserSubordinateResponse =
  paths[typeof USER_SUBORDINATE_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useUserSubordinateQuery(uuid: string, options?: Options<UserSubordinateParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<UserSubordinateParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
  };

  return useQuery({
    queryKey: [USER_SUBORDINATE_API_RESOURCE, uuid, USER_SUBORDINATE_API_OPERATION, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<UserSubordinateResponse>(
        `/v1/${USER_SUBORDINATE_API_RESOURCE}/${uuid}/${USER_SUBORDINATE_API_OPERATION}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
